import { ONBOARDING, ONBOARDING_DEFAULT_TIME } from '../constants/OnboardingConstants';
import { FONT_BASE } from '../constants/AppFonts';

export class GameHudOnboarding extends Phaser.GameObjects.Layer {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);
    this.onboardingElements = [];
  }

  showOnboarding(config) {
    this.closeOnboarding();
    const wrap = this.scene.add.container();
    const panel = this.scene.add.image(0, 0, 'ui', `onboarding_${config.side || 'bottom'}`);
    const label = this.scene.add
      .text(0, 0, config.text, {
        fontFamily: FONT_BASE.BEBAS_REGULAR,
        fontSize: '24px',
        color: '#000000',
        align: 'center',
        wordWrap: { width: panel.width - 150 },
      })
      .setOrigin(0.5);
    wrap.add([panel, label]);

    this.onboardingElements.push({ id: config.id, content: wrap });

    switch (config.side) {
      case 'left':
        label.y = -10;
        label.x = -15;
        break;
      case 'top':
        label.y = -25;
        break;
      case 'bottom':
        label.y = 0;
        break;
    }

    if (config.position?.hud_button) {
      const btn = this.scene.game.hud.getButton(config.position?.hud_button);
      const bounds = btn.getBounds();
      switch (config.side) {
        case 'left':
          config.position.x = bounds.x - panel.width * 0.5 + 10;
          config.position.y = bounds.y + bounds.height * 0.5 + 10;
          break;
        case 'top':
          break;
        case 'bottom':
          break;
      }
    } else {
      wrap.setPosition(config.position.x, 1000);
    }
    this.add(wrap);

    const min = this.scene.game.viewportController.left - 30 + panel.width * 0.5;
    const max = this.scene.game.viewportController.right + 30 - panel.width * 0.5;

    wrap.x = Math.min(max, Math.max(min, config.position.x));
    this.scene.tweens.add({
      targets: wrap,
      y: config.position.y,
      duration: 250 / 1,
      ease: Phaser.Math.Easing.Back.Out,
    });

    if (config.pointer) {
      const pointer = this.scene.add.image(
        config.pointer.from.x,
        config.pointer.from.y,
        'ui',
        'pointer'
      );
      this.add(pointer);
      this.scene.tweens.chain({
        targets: pointer,
        tweens: [
          {
            scale: { from: 0, to: 1 },
            ease: Phaser.Math.Easing.Back.Out,
            duration: 250 / 1,
          },
          {
            targets: pointer,
            x: { from: config.pointer.from.x, to: config.pointer.to.x },
            y: { from: config.pointer.from.y, to: config.pointer.to.y },
            duration: (config.pointer.duration || 1000) / 1,
            onComplete: config.pointer.onComplete,
            onUpdate: (e) => {
              config.pointer.onUpdate.call(config.pointer.callbackScope, pointer, e.progress);
            },
            callbackScope: config.pointer.callbackScope,
          },
          {
            scale: { from: 1, to: 0 },
            ease: Phaser.Math.Easing.Back.In,
            duration: 250 / 1,
            onComplete: () => pointer.destroy(),
          },
        ],
      });
    }

    this.currentVoId = config.vo;
    if (this.currentVoId) this.scene.game.vo.play(config.vo);

    if (config.autoClose) {
      this.closeOnboarding({
        delay: (config.autoClose.delay || config.text.length * ONBOARDING_DEFAULT_TIME) / 1,
        onComplete: config.autoClose.onComplete,
        onCompleteScope: config.autoClose.onCompleteScope,
      });
    }
  }
  closeOnboarding({ delay, onComplete, onCompleteScope } = {}) {
    if (!this.scene) return;
    if (this.onboardingElements.length) {
      const entry = this.onboardingElements.shift();
      if (this.currentVoId) this.scene.game.vo.stop(this.currentVoId);
      this.scene.tweens.add({
        targets: entry.content,
        y: 1000,
        duration: 250 / 1,
        ease: Phaser.Math.Easing.Back.In,
        delay: delay / 1,
        onComplete: () => {
          entry.content.destroy();
          if (onComplete) onComplete.apply(onCompleteScope);
        },
      });
    }
  }
}

export class OnboardingGeneric extends Phaser.GameObjects.Layer {
  constructor(scene, { bubble, pointer, autoClose }) {
    super(scene);
    scene.add.existing(this);
    if (pointer) this.addPointer(pointer);
  }

  addPointer(config) {
    if (this.pointer) this.pointer.destroy();
    this.pointer = this.scene.add.image(config.from.x, config.from.y, 'ui', 'pointer');
    const duration = Phaser.Math.Distance.BetweenPoints(config.from, config.to) * 1.5;
    this.add(this.pointer);
    this.scene.tweens.chain({
      targets: this.pointer,
      tweens: [
        {
          scale: { from: 0, to: 1 },
          ease: Phaser.Math.Easing.Back.Out,
          duration: 250 / 1,
        },
        {
          targets: this.pointer,
          x: { from: config.from.x, to: config.to.x },
          y: { from: config.from.y, to: config.to.y },
          duration: duration / 1,
        },
        {
          scale: { from: 1, to: 0 },
          ease: Phaser.Math.Easing.Back.In,
          duration: 250 / 1,
          onComplete: () => {
            this.pointer.destroy();
            if (config.onComplete) config.onComplete();
          },
        },
      ],
    });
  }
}

class OnboardingDescision extends OnboardingGeneric {
  constructor(scene) {
    super(scene, { bubble: ONBOARDING.choice_make });
    this.addPointer({
      from: { x: 840, y: 360 },
      to: { x: 540, y: 360 },
      onComplete: () => {
        this.addPointer({
          from: { x: 840, y: 360 },
          to: { x: 1140, y: 360 },
        });
      },
    });
  }
}

export const ONBOARDING_OVERLAYS = {
  GENERIC: OnboardingGeneric,
  DESCISION: OnboardingDescision,
};
